import { IPhoneData } from './bussines';

export enum PERMISSION_TYPE_IDS {
  VIEW = 1,
  EDIT = 2
}

export const PERMISSION_TYPES = {
  1: 'VIEW',
  2: 'EDIT'
};

export const CALENDLY_LINK_TYPE_ID = 1;

export type TpermissionId = keyof typeof PERMISSION_TYPES;

export enum BACKOFFICE_MODULES {
  COUNTRY = 'country',
  CATALOG = 'catalog',
  BRAND = 'brand',
  CATEGORY = 'category',
  ORDER = 'order',
  TRACKING_ORDER = 'trackingOrder',
  STOCK = 'stock',
  LOGISTIC_SERVICE = 'logisticService',
  ORGANIZATION = 'organization',
  BLOG = 'blog',
  CONFIGURATION = 'configuration',
  OPS_SUPPORT = 'opsSupport', // CAMBIAR-JC: Se debe reemplazar por el de TECH_SUPPORT
  TOOLS = 'tools',
  AI_CHAT = 'aiChat',
  TECH_SUPPORT = 'techSupport',
  BULK_UPLOAD = 'bulkUpload',
  EDIT_PRICES = 'editPrices',
  ANNOUNCEMENT = 'announcement'
}

export type IgetBackofficeConfigurationResponse = {
  permissionGroups: IpermissionGroups;
  usersPermissions: IusersPermissionsData[];
};

export interface IpermissionGroups {
  [key: string]: IpermissionGroupData;
}

export interface IpermissionGroupData {
  id: number;
  permissions: IpermissionData;
}

export type IpermissionData = {
  [key in BACKOFFICE_MODULES]?: TpermissionId[];
};

export interface IpermissionAndGroupData {
  permissionGroups: {
    id?: number;
    name?: string;
  }[];
  permissions: IpermissionData;
}

export interface IbackofficeUserData {
  id: number;
  firstName: string;
  lastName: string;
  uid: string;
  email: string;
  phone: string;
  countryCode: string;
  dataPhone?: IPhoneData;
  countryId: number;
  photoProfile: string;
  stateId: number;
  onboarding: string;
  deletedAt: string;
  createdAt: string;
  updatedAt: string;
  userId?: number;
}

export interface IUserAdditionalData {
  id: number;
  userId: number;
  responsibleUserId: number | null;
  additionalDataTypeId: number;
  value: string;
  validUntil: Date | null;
}

export interface IUpdateUserAccountDto {
  firstName?: string;
  lastName?: string;
  phone?: string;
  countryCode?: string;
  countryId?: string;
  countryPhoneId?: string;
  photoProfile?: string;
}

export interface IPhotoProfile {
  file?: File;
  url?: string;
}

export interface ICreateUserAdditionalDataDto {
  userId: number;
  additionalDataTypeId: number;
  value?: string;
  responsibleUserId?: number;
}

export interface IusersPermissionsData {
  id: number;
  countryId: number;
  email: string;
  firstName: string;
  lastName: string;
  userRole: { roleId: number };
  userPermissionGroups: IuserPermissionsGroups[];
}
export interface IuserPermissionsGroups {
  permissionGroupId: number;
}

export interface IIupdatePermissionsGroupByUser {
  userId: number;
  newPermissionGroups: number[];
  lastEditUserId: number;
}

export interface IgetLoggedUserPermissionsResponse {
  userData: IbackofficeUserData;
  permissions: IpermissionAndGroupData;
}

export interface IUser {
  id: number;
  firstName: string;
  lastName: string;
  email: string;
  photoUrl?: string;
}
